import { useNavigate } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
  onClick?: () => void;
}

const sizeMap: Record<string, string> = {
  sm: 'h-10',
  md: 'h-12',
  lg: 'h-16',
  xl: 'h-20',
  '2xl': 'h-24',
};

const LOGO_URL = 'https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/b4376f03a420b528e644adf3c7106744.png';

export default function Logo({ size = 'md', className = '', onClick }: LogoProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <img
      src={LOGO_URL}
      alt="RadioFrecuenciaWeb"
      className={`object-contain ${sizeMap[size]} w-auto ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={handleClick}
    />
  );
}

export function LogoLink({ size = 'md', className = '', href = '#inicio' }: Omit<LogoProps, 'onClick'> & { href?: string }) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else if (href.startsWith('/')) {
      navigate(href);
    }
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className={`flex items-center cursor-pointer ${className}`}
    >
      <img
        src={LOGO_URL}
        alt="RadioFrecuenciaWeb"
        className={`object-contain ${sizeMap[size]} w-auto`}
      />
    </a>
  );
}